import styled from 'styled-components';

interface BaseProps {
	selected?: boolean;
	active?: boolean;
	disabled?: boolean;
}

export const Base = styled.button<BaseProps>`
	background: none;
	border: none;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	height: 40px;
	border-radius: 4px;

	${({ selected, active, theme }) =>
		(selected || active) &&
		`
	background-color: ${theme.gray[200]};
`}

	${({ disabled }) =>
		disabled &&
		`
		opacity: 0.5;
		pointer-events: none;
	`}

	&:hover {
		background-color: ${({ theme, disabled, selected, active }) =>
			disabled ? 'transparent' : selected || active ? theme.gray[200] : theme.gray[100]};
	}
`;

